import styled from "styled-components";

const Title = styled.h1`
  font-size: 24px;
  font-weight: medium;
  color: #323232;
`;

export default Title;
